import { getTime } from '@utils'
import classNames from 'classnames'
import { get } from 'lodash-es'

export default function RatingValuation({
  data,
  children
}) {

  const publicRecords = get(data, 'publicRecords')
  const rateableValueChange = (() => {
    const rvChange = get(publicRecords, 'rateableValueChange')
    const lastValuationAt = get(publicRecords, 'lastValuationAt')
    const year = getTime(lastValuationAt, 'YYYY')
    return {
      label: `RV (${getTime(get(publicRecords, 'valuationAt'), 'MMM YYYY')})`,
      price: get(publicRecords, 'rateableValue'),
      sub: `${rvChange > 0 ? 'Increased by' : 'Reduced by'} ${Math.abs(rvChange)}% (Compared to ${year})`,
      up: rvChange > 0,
      change: rvChange
    }
  })()
  const improvementValueChange = (() => {
    const ivChange = get(publicRecords, 'improvementValueChange')
    const lastValuationAt = get(publicRecords, 'lastValuationAt')
    const year = getTime(lastValuationAt, 'YYYY')
    return {
      label: 'Improvement value',
      price: get(publicRecords, 'improvementValue'),
      sub: `${ivChange > 0 ? 'Increased by' : 'Reduced by'} ${Math.abs(ivChange)}% (Compared to ${year})`,
      up: ivChange > 0,
      change: ivChange
    }
  })()
  const landValueChange = (() => {
    const lvChange = get(publicRecords, 'landValueChange')
    const lastValuationAt = get(publicRecords, 'lastValuationAt')
    const year = getTime(lastValuationAt, 'YYYY')
    return {
      label: 'Land value',
      price: get(publicRecords, 'landValue'),
      sub: `${lvChange > 0 ? 'Increased by' : 'Reduced by'} ${Math.abs(lvChange)}% (Compared to ${year})`,
      up: lvChange > 0,
      change: lvChange
    }
  })()
  return (
    <section className='grid grid-cols-1 gap-20 md:grid-cols-[1fr,220px] xl:grid-cols-[1fr,292px]'>
      <aside className='flex flex-col items-center justify-between border rounded-b-sm md:flex-row md:border-0 md:pl-20'>
        {
          rateableValueChange && <RVItem data={rateableValueChange}></RVItem>
        }
        <span className='text-[40px] my-20 sm:mx-20 lg:mx-60'>=</span>
        <div className='flex-1 w-full p-20 bg-neutral-1 flex items-center md:p-0 md:bg-transparent'>
          {
            improvementValueChange && <RVItem data={improvementValueChange}></RVItem>
          }
          <span className='text-[40px] mx-auto'>+</span>
          {
            landValueChange && <RVItem data={landValueChange}></RVItem>
          }
        </div>
      </aside>
      {children}
    </section>
  )
}

function RVItem({
  data
}) {

  const { up, label, price, sub, change } = data
  return (
    <div className='max-w-150 text-center md:text-left'>
      {
        change && (
          <i className={classNames('icon icon-up text-secondary inline-block', { 'rotate-180': !up })}></i>
        )
      }
      <div className='text-font text-xl mt-14 whitespace-nowrap'>{label}</div>
      <div className='text-font text-3xl mt-6'>{price}</div>
      {
        change && (
          <div className='text-secondary text-base mt-24'>{sub}</div>
        )
      }
    </div>
  )
}